import React from 'react';
import { CtaBlock } from './ui/CtaBlock';
import { BONUS_TOTAL, OFFER_ANCHOR, PACK_IMAGE, PACK_IMAGE_ALT, PRICE, PRODUCT_NAME } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="cierre" className="bg-mist" data-id="element-53" data-mp="c7adc3u6m4g0">
      <div className="mx-auto max-w-xl px-4 py-4 text-center sm:py-8" data-id="element-54" data-mp="c4o665b7dqyb">
        <h2 id="cierre" className="font-display text-2xl font-black text-navy sm:text-4xl" data-id="element-55" data-mp="84e3b1ipjgno">
          Una última oportunidad
        </h2>
        <p className="mt-1 text-sm leading-snug text-navy/75" data-id="element-56" data-mp="m2lvkw4sttsi">
          Puedes seguir buscando circuitos, ejercicios, prácticas y actividades cada vez que tienes que preparar una
          clase. O puedes comenzar hoy a organizar tu material siguiendo una ruta desde fundamentos y componentes hasta
          mediciones, diagnóstico y proyectos.
        </p>
        <p className="mt-1.5 font-display text-sm font-bold text-navy sm:text-base" data-id="element-57" data-mp="14w7xkchyebbe">
          No necesitas preparar cada clase desde cero.{' '}
          <span className="bg-energy px-1 font-extrabold" data-id="element-58" data-mp="2c4o9os7okz43">
            Necesitas una estructura que puedas consultar, adaptar y llevar a la práctica.
          </span>
        </p>

        <div className="mt-3 rounded-xl border-2 border-navy bg-white p-3.5" data-id="element-59" data-mp="2h5u36s960qeo">
          <a href={OFFER_ANCHOR} aria-label="Ir a la sección de compra" className="mx-auto block max-w-[15rem] overflow-hidden rounded-md transition-transform duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] active:scale-[0.99]" data-id="element-60" data-mp="2m19fhfriye8z">
            <img src={PACK_IMAGE} alt={PACK_IMAGE_ALT} className="block w-full" data-id="element-61" data-mp="301u26n0k8u7r" />
          </a>
          <p className="mt-2 font-condensed text-sm font-bold text-brand" data-id="element-62" data-mp="34t29ndiby5ia">⚡ {PRODUCT_NAME}</p>
          <p className="font-numeric text-2xl leading-tight tracking-wide text-navy" data-id="element-63" data-mp="39solpjmf9fpi">6 Tomos + 5 Bonos</p>
          <p className="text-sm text-navy/70" data-id="element-64" data-mp="3esb0vylt960y">
            Valor de los bonos: <span className="line-through decoration-alert decoration-2" data-id="element-65" data-mp="3it3bav6f5gyt">{BONUS_TOTAL}</span>
          </p>
          <p className="font-numeric text-5xl leading-tight tracking-wide text-navy sm:text-6xl" data-id="element-66" data-mp="1jo3ijkadab53">
            Hoy: <span className="text-brand" data-id="element-67" data-mp="1epief9rzv7bd">{PRICE}</span>
          </p>
          <CtaBlock note="Acceso Inmediato • Entrega Digital • Garantía de 7 Días" data-id="element-68" data-mp="1en5sklj48ct1" />
        </div>
      </div>
    </section>;
}